import { not } from 'ramda';

function getDateFormat(date) {
  let newDate = date;

  if (not(date instanceof Date)) {
    newDate = new Date(date);
  }
  return newDate;
}

export default getDateFormat;
